import { AssertException } from '../assert.exception';

export class AssertMustContainUniqueArrayElementsException extends AssertException {
  constructor(message?: string) {
    super(message);

    Object.setPrototypeOf(this, AssertMustContainUniqueArrayElementsException.prototype);
  }
}
